import React from 'react'
import F from '../components/Faqs';

const Faqs = () => {
  return (
    <F/>
  )
}

export default Faqs